angular.module('unergie.main')
.directive('queryNode', (AlertManager, DataModelService) =>
    ({
        restrict: 'E',
        templateUrl: '/states/ogcContactListsModal/queryNode/queryNode.html',
        scope: {
            data: '=',
            first: '=',
            model: '=',
        },
        link($scope) {
            $scope.search = { newField: '' }
            $scope.operatorConf = {}
            const getStrippedType = (type) => type.split(' ')[0].split('(')[0].split('[')[0].replace(/"/g, '')

            const textOperators = [
                { id: 'like', label: 'Contient' },
                { id: 'not like', label: 'Ne contient pas' },
                { id: 'not in', label: `Différent de` },
                { id: 'in', label: 'Égale à' },
                { id: 'is', label: `N'est pas renseigné` },
                { id: 'is not', label: `est renseigné` },
            ]

            const numberOperators = [
                { id: '=', label: 'Égal à' },
                { id: '<>', label: `Différent de` },
                { id: '<', label: 'Inférieur à' },
                { id: '<=', label: 'Inférieur ou égal à' },
                { id: '>', label: 'Supérieur à' },
                { id: '>=', label: 'Supérieur ou égal à' },
                { id: 'is', label: `N'est pas renseigné` },
                { id: 'is not', label: `est renseigné` },
            ]

            const dateOperators = [
                { id: 'is', label: `N'est pas renseigné` },
                { id: 'is not', label: `est renseigné` },
                { id: '<', label: 'Avant' },
                { id: '>', label: 'Après' },
                { id: '<-days', label: 'Plus de n jours (dans le passé)' },
                { id: '>-days', label: 'Moins de n jours (dans le passé)' },
                { id: '<-month', label: 'Plus de n mois (dans le passé)' },
                { id: '>-month', label: 'Moins de n mois (dans le passé)' },
                { id: '>+days', label: 'Plus de n jours (dans le futur)' },
                { id: '<+days', label: 'Moins de n jours (dans le futur)' },
                { id: '>+month', label: 'Plus de n mois (dans le futur)' },
                { id: '<+month', label: 'Moins de n mois (dans le futur)' },
            ]

            $scope.isExistenceOperator = (operator) => {
                return ['is', 'is not'].includes(operator)
            }

            $scope.isIntervalDate = (type, operator) => {
                return type === 'date' && !['<', '>', 'is', 'is not'].includes(operator)
            }

            const booleanOperator = [{ id: '=', label: 'Est' }]

            const getOperatorConf = (type) => {
                const strippedType = getStrippedType(type)
                switch (strippedType) {
                    case 'smallint':
                    case 'bigint':
                    case 'double':
                    case 'integer':
                    case 'numeric':
                        return { operators: numberOperators, valueType: 'number' }
                    case 'timestamp':
                    case 'date':
                        return { operators: dateOperators, valueType: 'date' }
                    case 'name':
                    case 'text':
                    case 'char':
                    case 'character':
                        return { operators: textOperators, valueType: 'text' }
                    case 'account_category':
                        return {
                            operators: booleanOperator,
                            valueType: 'select',
                            values: [
                                { id: 'part', label: 'Particulier' },
                                { id: 'small-business', label: 'Petit Pro' },
                                { id: 'pro', label: 'Professionel' },
                                { id: 'user', label: 'Utilisateur Backoffice' },
                            ],
                        }
                    case 'boolean':
                        return {
                            operators: booleanOperator,
                            valueType: 'select',
                            values: [
                                { id: true, label: 'Vrai' },
                                { id: false, label: 'Faux' },
                            ],
                        }
                    case 'json':
                    default:
                        AlertManager.error(`Type de champ non géré : ${type}, traité comme texte`)
                        return { operators: textOperators, valueType: 'number' }
                }
            }

            $scope.operatorChanged = (item) => {
                if ($scope.isExistenceOperator(item.operator)) {
                    delete item.value
                }
            }

            $scope.selectNewField = (field) => {
                $scope.data.new.field = field
                $scope.operatorConf = getOperatorConf(field.type)
            }

            $scope.formatCriteria = (field, value) => {
                const conf = _.find($scope.schemaDef, { field })
                if (!conf) {
                    return `[${field}] <i>${value[0]}</i> "${value[1]}"`
                }
                const operatorConf = getOperatorConf(conf.type)
                const operator = _.find(operatorConf.operators, { id: value[0] })
                let html = `[${conf.description}] <i>${operator.label}</i> `
                if (!$scope.isExistenceOperator(value[0])) {
                    html += `"${(operatorConf.valueType === 'date' && !$scope.isIntervalDate(operatorConf.valueType, value[0])) ? moment(value[1]).format('DD/MM/YYYY') : value[1]}"`
                }
                return html
            }

            DataModelService.getDataModel($scope.model.modelName).then((shemaDef) => {
                $scope.schemaDef = shemaDef
            })

            $scope.logicalOperators = {
                '#and': 'Et',
                '#or': 'Ou',
            }

            $scope.isOperator = (key) => {
                return ['#or', '#and'].includes(key)
            }

            $scope.isField = (key) => {
                return !['#or', '#and', 'edit', 'new'].includes(key)
            }

            $scope.addCriterion = (array) => {
                $scope.model.editMode = true
                array.push({
                    new: {
                        field: undefined,
                        operator: undefined,
                        value: undefined,
                    },
                })
            }

            $scope.addAnd = (array) => {
                $scope.model.editMode = true
                array.push({ '#and': [{
                    new: {
                        field: undefined,
                        operator: undefined,
                        value: undefined,
                    },
                }] })
            }

            $scope.addOr = (array) => {
                $scope.model.editMode = true
                array.push({ '#or': [{
                    new: {
                        field: undefined,
                        operator: undefined,
                        value: undefined,
                    },
                }] })
            }

            $scope.saveNew = (payload) => {
                $scope.search.newField = undefined
                _.each(Object.keys($scope.data), (key) => {
                    delete $scope.data[key]
                })
                $scope.data[payload.field.field] = [
                    payload.operator,
                    (payload.field.type === 'date' && !$scope.isIntervalDate(payload.field.type, payload.operator)) ? moment(payload.value).toISOString() : payload.value,
                ]
                $scope.model.editMode = false
            }

            $scope.cancelNew = (payload) => {
                $scope.search.newField = undefined
                delete $scope.data.new
                $scope.model.editMode = false
            }

            $scope.emptyNewFieldTypeahead = () => {
                $scope.search.newField = undefined
                $scope.data.new.field = undefined
            }

            $scope.editCriteria = (key, value) => {
                $scope.model.editMode = true
                const field = _.find($scope.schemaDef, { field: key })
                $scope.search.newField = field.description
                $scope.data.new = {
                    field,
                    operator: value[0],
                    value: field.type === 'date' && !$scope.isIntervalDate(field.type, value[0]) ? moment(value[1]).toDate() : value[1],
                }
                $scope.operatorConf = getOperatorConf(field.type)
            }

            $scope.delete = (key) => {
                delete $scope.data[key]
            }
        },
    })
)
